__turbopack_context__.v({
  "article_container": "styles-module-scss-module__twttSW__article_container",
  "article_details": "styles-module-scss-module__twttSW__article_details",
  "blog_count": "styles-module-scss-module__twttSW__blog_count",
  "card_outer": "styles-module-scss-module__twttSW__card_outer",
  "no_side_bar": "styles-module-scss-module__twttSW__no_side_bar",
  "search": "styles-module-scss-module__twttSW__search",
  "search_bar": "styles-module-scss-module__twttSW__search_bar",
  "show_more": "styles-module-scss-module__twttSW__show_more",
  "side_bar": "styles-module-scss-module__twttSW__side_bar",
  "spinner": "styles-module-scss-module__twttSW__spinner",
  "state_sort": "styles-module-scss-module__twttSW__state_sort",
  "summary": "styles-module-scss-module__twttSW__summary",
  "tabs": "styles-module-scss-module__twttSW__tabs",
  "zero_state": "styles-module-scss-module__twttSW__zero_state",
});
